import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Airflow per projects",
    },
  },
};

function ChartBar(props) {
  function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
      : "0";
  }
  const { t } = useTranslation();
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: t("home.totalCostPerTypeAndCountry"),
      },
    },
    scales: {
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, ticks) {
            return "€" + nFormatter(value, 2);
          },
        },
      },
    },
  };

  const labels = [];
  const enthalpyCost_data = [];
  const plateCost_data = [];
  const rotaryCost_data = [];

  props.data.map((item) => {
    labels.push(
      t(
        `registration.country.${
          item.country[0].toLowerCase() + item.country.slice(1)
        }`
      )
    );
    enthalpyCost_data.push(item.enthalpyCost);
    plateCost_data.push(item.plateCost);
    rotaryCost_data.push(item.rotaryCost);
  });

  const data = {
    labels,
    datasets: [
      {
        label: t("home.enthalpy"),
        data: enthalpyCost_data,
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: t("home.plate"),
        data: plateCost_data,
        backgroundColor: "rgba(255, 206, 86, 0.5)",
      },
      {
        label: t("home.rotary"),
        data: rotaryCost_data,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  return (
    <>
      <Bar options={options} data={data} />
    </>
  );
}

export default React.memo(ChartBar);
